export const TYPE_ORDER_DETAILS = 'order_details';
